import { IActivityTrackingSet } from "@ms-ofb/floodgate-shared-typings";
import { ActivityTrackingData } from "./ActivityTrackingData";
import SurveyActivityListener from "./SurveyActivityListener";
import { isNOU } from "./Utils";

/**
 * Class to hold a collection of Activity Tracking Data
 */
export class ActivityTrackingSet implements IActivityTrackingSet {
	private isOrdered: boolean;
	private list: ActivityTrackingData[];

	public constructor(isOrdered: boolean, list: ActivityTrackingData[]) {
		this.isOrdered = isOrdered;
		this.list = list;
	}

	public getIsOrdered(): boolean {
		return this.isOrdered;
	}

	public getList(): ActivityTrackingData[] {
		return this.list;
	}

	// returns a stringified json with the list and isOrdered info.
	public getActivityTrackingInfo(activityListener: SurveyActivityListener, surveyId: string): string {

		let activitiesInfoObject: {
			Activities: Array<{ Activity: string, Count: number, IsAggregate: boolean }>,
			IsListOrdered: boolean,
		};

		if (this.list.length === 0) {
			activitiesInfoObject = {
				Activities: [],
				IsListOrdered: this.isOrdered,
			};

			return JSON.stringify(activitiesInfoObject);
		}

		for (const trackingData of this.list) {

			const actualCount = activityListener.getCount(trackingData.getActivity(), surveyId);
			const tempActivities = {
				Activity: trackingData.getActivity(),
				ActualCount: actualCount,
				Count: trackingData.getCount(),
				IsAggregate: trackingData.getIsAggregate(),
				IsDiscrete: actualCount % 1 === 0,
			};

			if (isNOU(activitiesInfoObject)) {
				activitiesInfoObject = {
					Activities: [tempActivities],
					IsListOrdered: this.isOrdered,
				};
			} else {
				activitiesInfoObject.Activities.push(tempActivities);
			}
		}

		return JSON.stringify(activitiesInfoObject);
	}
}
